var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPolarPlusDefault = function SvgPolarPlusDefault(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 195.93",
    height: 40,
    "aria-labelledby": titleId,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "bp-pulse-title"
  }, "bp pulse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "bp-pulse-title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.39 24.45A28.92 28.92 0 1 0 200 53.36a28.81 28.81 0 0 0-28.61-28.91zm11.16 32.1h-5.1a3.23 3.23 0 0 0-3.15 3.18v5.15a3.15 3.15 0 1 1-6.3 0v-5.15a3.22 3.22 0 0 0-3.15-3.18H160a3.24 3.24 0 0 1-2.91-3.43 3.63 3.63 0 0 1 2.91-2.94h5.09a3.22 3.22 0 0 0 3.15-3.18v-5.15a3.16 3.16 0 1 1 6.31 0V47a3.22 3.22 0 0 0 3.15 3.19h5.09a3.23 3.23 0 0 1 2.91 3.43 3.19 3.19 0 0 1-3.15 2.93z",
    fill: "#2f67bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.27 53.36a36.15 36.15 0 0 1 7.52-22L91.88 1.65a12.87 12.87 0 0 0-12.61 0L6.3 44.3a12.57 12.57 0 0 0-6.3 11v85.29a12.57 12.57 0 0 0 6.3 11l73.22 42.65a12.85 12.85 0 0 0 12.6 0l73.21-42.65a12.58 12.58 0 0 0 6.31-11V89.88a36.79 36.79 0 0 1-36.37-36.52z",
    fill: "#3cc0f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.36 140.85A42.89 42.89 0 1 1 128 98a42.78 42.78 0 0 1-42.64 42.85zm0-24.5A18.38 18.38 0 1 0 67.07 98a18.33 18.33 0 0 0 18.29 18.35z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.48 86.066l23.198-43.592 4.555 2.424L76.035 88.49zm12.667 1.537l23.197-43.591 4.556 2.424-23.198 43.591zm10.425 5.534l23.198-43.592 4.555 2.425-23.197 43.59z",
    fill: "#3cc0f5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPolarPlusDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "polar-plus-default.4f4ca8e3cd54323d2a6f26d3b1301d7f.svg";